// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"u2-z","colorTextValue":"v2-z","swatches":"w2-z","collapseLink":"x2-z","isCollapsed":"y2-z","dropdown":"z2-z","disabled":"A2-z"};